import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { SmallPortalTooltip } from '../../Tooltip';
import {
  TooltipContent,
  TooltipDetail,
  TooltipTitle,
} from '../Progress/Tooltip';

dayjs.extend(utc);

export default function DateCellContent({
  date,
  label,
}: {
  date: Date | null;
  label: string;
}) {
  const id = `date-${label}`;

  if (!date) {
    return <span className={id}>-</span>;
  }
  const visibleDate = dayjs.utc(date).format('YYYY-MM-DD HH:mm');

  return (
    <>
      <div data-tooltip-id={id}>{visibleDate}</div>
      <SmallPortalTooltip anchorSelect={`[data-tooltip-id="${id}"]`}>
        <TooltipContent>
          <TooltipTitle>{label}</TooltipTitle>
          <TooltipDetail>
            {dayjs.utc(date).format('YYYY-MM-DD HH:mm')}
          </TooltipDetail>
          <TooltipDetail>{dayjs.utc(date).fromNow()}</TooltipDetail>
        </TooltipContent>
      </SmallPortalTooltip>
    </>
  );
}
